<template>
    <AboutGame></AboutGame>
</template>

<script>
export default {
    components: {
        AboutGame: resolve => {
            resolve({
                data() {
                    return {
                        gameName: Config.game_name.toLowerCase(),
                        logoLink: Config.logoByLanguage,
                        maxQuote: Config.max_quote,
                        maxAmount: Config.max_amount,
                        additionalTutorialInfo: Config.additionalTutorialInfo,
                        displayPercent: Config.display_percent,
                        percent: Config.percent,
                        version: Config.version,
                    };
                },
                template: Config.tutorial_template,
                mounted() {
                },
                computed: {
                    implodedAmounts() {
                        let imploded = "";
                        const amountsLength = Object.entries(Config.amounts).length - 1;

                        for(const [key, value] of Object.entries(Config.amounts)) {
                            imploded += this.$options.filters.currency(value.amount) + (parseInt(key) !== parseInt(amountsLength) ? ', ' : '');
                        }

                        return imploded;
                    }, 
                    winUpFormatted() {
                        return this.$options.filters.currency(this.maxQuote * this.maxAmount);
                    }
                }
            });
        },
    },
}
</script>